<template>
  <div class="docs">
    <div class="col-md-12 jumbotron my-3 p-3">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Model</th>
            <th scope="col">Email</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in cx_waitlist" :key="index">
            <th scope="row">{{ data.id }}</th>
            <td>{{ data.model }}</td>
            <td>
              <span class="badge badge-primary">{{ data.emailId }}</span>
            </td>
            <td style="white-space: nowrap;">
              {{ data.createdAt | moment("LLL") }}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="mt-5 col-md-12 text-center"
        v-if="cx_waitlist.status == 0 && !makingAJAX"
      >
        <p>We didn't get any data.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  created() {
    this.$store.state.customer_by_number = [];
    this.phone_number = this.$route.params.phone;
    this.cx_id = this.$route.params.cx_id;
    this.currentTab = this.$route.query.tab;
    if (this.phone_number) {
      this.$store.dispatch("get_customer_waitlist", { id: this.cx_id });
    } else {
      this.showModal = true;
    }
  },
  computed: {
    makingAJAX() {
      return this.$store.state.makingAJAX;
    },
    cx_waitlist() {
      return this.$store.state.customer_waitlist;
    },
  },
};
</script>

<style></style>
